class MobileMenu {
	constructor() {
		this.menuIconSelector = ".site-header__menu-icon"
		this.menuContentSelector = ".site-header__menu-content"
		this.siteHeaderSelector = ".site-header"
		this.openClass = "site-header--is-expanded"
		this.contentVisibleClass = "site-header__menu-content--is-visible"
		this.iconCloseClass = "site-header__menu-icon--close-x"
		this.bodyLockClass = "hidescroll"

		this.events()
	}

	events() {
		document.addEventListener("click", (event) => {
			const menuIcon = event.target.closest(this.menuIconSelector)

			if (!menuIcon) {
				return
			}

			event.preventDefault()
			event.stopPropagation()

			const siteHeader = menuIcon.closest(this.siteHeaderSelector) || document.querySelector(this.siteHeaderSelector)
			const menuContent = siteHeader ? siteHeader.querySelector(this.menuContentSelector) : document.querySelector(this.menuContentSelector)

			if (!siteHeader || !menuContent) {
				console.warn("Mobile menu could not find header or menu content.")
				return
			}

			this.toggleTheMenu(siteHeader, menuContent, menuIcon)
		}, true)
	}

	toggleTheMenu(siteHeader, menuContent, menuIcon) {
		menuContent.classList.toggle(this.contentVisibleClass)
		siteHeader.classList.toggle(this.openClass)
		menuIcon.classList.toggle(this.iconCloseClass)
		document.body.classList.toggle(this.bodyLockClass)

		const isOpen = siteHeader.classList.contains(this.openClass)

		menuIcon.setAttribute("aria-expanded", isOpen ? "true" : "false")
		menuIcon.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu")
	}
}

export default MobileMenu
